export const getIsAchievementsEnabled = (achievementsEnabled?: boolean) =>
  achievementsEnabled ?? false;

export const getIsUploadPractiseSectionEnabled = (
  uploadPractiseSectionEnabled?: boolean
) => uploadPractiseSectionEnabled ?? false;

export const getIsUploadActivitySheetEnabled = (
  uploadActivitySheetEnabled?: boolean
) => uploadActivitySheetEnabled ?? false;

export const getIsChatEnabled = (chatEnabled?: boolean) => chatEnabled ?? false;

export const getIsLessonAudioEnabled = (lessonAudioEnabled?: boolean) =>
  lessonAudioEnabled ?? false;

export const getIsLessonImageEnlargementEnabled = (
  lessonImageEnlargementEnabled?: boolean
) => lessonImageEnlargementEnabled ?? false;

// BLD2-363: Assignment submission panel — off until submission slices are ready
export const getIsAssignmentSubmitPanelEnabled = (
  assignmentSubmitPanelEnabled?: boolean
) => assignmentSubmitPanelEnabled ?? false;

/**
 * Returns true if assignment work sample uploads should be shown.
 *
 * The backend `assignment_work_sample_uploads_enabled` Waffle flag (per grade
 * group) is the single source of truth. The MFE adds no grade-based gating of
 * its own.
 *
 * Historical note: this gate used to carry two extra clauses that have since
 * been removed —
 *   - `!isAssessed` (BLD2-676 → BLD2-915) assumed "assessed" was a proxy for
 *     "Senior". After BLD2-852/853 made assessed a per-term signal, it was
 *     hiding the panel for legitimate F-10 students. Removed in BLD2-981.
 *   - `!isSeniorGrade` (BLD2-676) hard-coded the panel as F-10 only. Product
 *     confirmed the keepsake panel should also show for Senior (G11-12) in
 *     BLD2-981, so grade scoping now lives solely in the backend flag.
 *
 * The keepsake panel and the submit-for-marking flow are not mutually
 * exclusive at the UI layer — a marking-enabled student can see both.
 *
 * @param grade - Grade context carrying the work sample uploads flag
 * @returns true if work sample features should be shown
 */
export const getIsAssignmentWorkSampleUploadsEnabled = (
  grade: { assignmentWorkSampleUploadsEnabled?: boolean } | null | undefined
): boolean => grade?.assignmentWorkSampleUploadsEnabled ?? false;
